export const MAX_ADDRESS_LENGTH = 100;
export const MAX_NAME_LENGTH = 30;

export const rules = {
  addressLine1: (v) =>
    !v.trim()
      ? "Address is required"
      : v.trim().length < 10
        ? "Enter complete address"
        : v.trim().length > MAX_ADDRESS_LENGTH
          ? `Address must be ${MAX_ADDRESS_LENGTH} characters or less`
        : "",
  city: (v) =>
    !v.trim()
      ? "City is required"
      : !/^[a-zA-Z\s]+$/.test(v.trim())
        ? "Letters only"
        : "",
  state: (v) =>
    !v.trim()
      ? "State is required"
      : !/^[a-zA-Z\s]+$/.test(v.trim())
        ? "Letters only"
        : "",
  pincode: (v) =>
    !v.trim()
      ? "PIN code is required"
      : /[^0-9]/.test(v.trim())
        ? "Numbers only"
        : v.trim().length !== 6
          ? "Must be 6 digits"
          : "",
};

export const ADDR_REQUIRED = [
  "name",
  "mobile",
  "email",
  "address",
  "city",
  "state",
  "pincode",
];

export const ADDRESS_TYPES = ["Home", "Work", "Other"];

export const validateAddr = (name, value) => {
  switch (name) {
    case "name":
      return !value?.trim()
        ? "Name is required"
        : value.trim().length < 2
          ? "Min 2 characters"
          : value.trim().length > MAX_NAME_LENGTH
            ? `Name must be ${MAX_NAME_LENGTH} characters or less`
            : "";
    case "email":
      return !value?.trim()
        ? "Email is required"
        : !/^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/.test(value.trim())
          ? "Enter a valid email address"
          : "";
    case "mobile":
      return !value?.trim()
        ? "Mobile number is required"
        : !/^[6-9]\d{9}$/.test(value.trim())
          ? "Enter a valid 10-digit mobile number"
          : "";
    case "address":
      return !value?.trim()
        ? "Address is required"
        : value.trim().length < 10
          ? "Enter complete address"
          : value.trim().length > MAX_ADDRESS_LENGTH
            ? `Address must be ${MAX_ADDRESS_LENGTH} characters or less`
          : "";
    case "city":
      return !value?.trim()
        ? "City is required"
        : !/^[a-zA-Z\s]+$/.test(value.trim())
          ? "Letters only"
          : "";
    case "state":
      return !value?.trim()
        ? "State is required"
        : !/^[a-zA-Z\s]+$/.test(value.trim())
          ? "Letters only"
          : "";
    case "pincode":
      return !value?.trim()
        ? "Pincode is required"
        : /[^0-9]/.test(value.trim())
          ? "Numbers only"
          : value.trim().length !== 6
            ? "Must be 6 digits"
            : "";
    case "latitude": {
      const latStr = String(value ?? "").trim();
      if (!latStr) return "";
      const lat = parseFloat(latStr);
      if (isNaN(lat)) return "Enter a valid number";
      if (lat < -90 || lat > 90) return "Latitude must be between -90 and 90";
      return "";
    }
    case "longitude": {
      const lngStr = String(value ?? "").trim();
      if (!lngStr) return "";
      const lng = parseFloat(lngStr);
      if (isNaN(lng)) return "Enter a valid number";
      if (lng < -180 || lng > 180) return "Longitude must be between -180 and 180";
      return "";
    }
    default:
      return "";
  }
};

export const EMPTY_ADDR = {
  name: "",
  mobile: "",
  email: "",
  address_type: "Home",
  address: "",
  city: "",
  state: "",
  pincode: "",
  latitude: "",
  longitude: "",
  gstin: "",
  is_default: false,
};
